/* Hochzeitsdatum-Liefer-Check
 * Fertigung 3–5 Werktage + DHL 1–2 Werktage:
 *  - Standard (konservativ): 7 Werktage
 *  - Express (optimistisch): 4 Werktage
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'soon_hochzeitsdatum';
  var WERKTAGE_STANDARD = 7;
  var WERKTAGE_EXPRESS = 4;
  var PUFFER_TAGE = 2;

  function addWerktage(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }

  function formatDatum(d) {
    return d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long' });
  }

  function tageBis(von, bis) {
    return Math.round((bis - von) / 86400000);
  }

  function init(root) {
    if (root.dataset.lieferInit) return;
    root.dataset.lieferInit = '1';

    var input = root.querySelector('[data-liefer-datum]');
    var result = root.querySelector('[data-liefer-result]');
    var optin = root.querySelector('[data-liefer-optin]');

    var heute = new Date();
    heute.setHours(0, 0, 0, 0);

    /* Vergangene Daten im Picker ausblenden */
    input.min = heute.toISOString().slice(0, 10);

    function update() {
      var v = input.value;

      /* Nur gefüllte Angaben mitbestellen */
      if (v) {
        input.name = 'properties[Hochzeitsdatum]';
        try { window.localStorage.setItem(STORAGE_KEY, v); } catch (e) { /* privat-modus */ }
      } else {
        input.removeAttribute('name');
        result.hidden = true;
        if (optin) {
          optin.hidden = true;
          optin.querySelector('input').checked = false;
        }
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) { /* privat-modus */ }
        return;
      }
      if (optin) optin.hidden = false;

      var hochzeit = new Date(v + 'T00:00:00');
      var lieferung = addWerktage(heute, WERKTAGE_STANDARD);
      var expressLieferung = addWerktage(heute, WERKTAGE_EXPRESS);
      var status, text;

      if (hochzeit < heute) {
        status = 'warn';
        text = 'Das Datum liegt in der Vergangenheit – bitte prüft eure Eingabe.';
      } else if (tageBis(lieferung, hochzeit) >= PUFFER_TAGE) {
        status = 'ok';
        text = '✓ Rechtzeitig da: Zustellung voraussichtlich bis ' + formatDatum(lieferung) +
          ' – ' + tageBis(lieferung, hochzeit) + ' Tage vor eurer Hochzeit.';
      } else if (hochzeit >= expressLieferung) {
        status = 'warn';
        text = 'Das wird knapp – mit Express-Fertigung klappt es in der Regel. ' +
          'Schreibt uns nach der Bestellung kurz an hi@soonwedding.de, wir priorisieren euch.';
      } else {
        status = 'warn';
        text = 'Weniger als ' + WERKTAGE_EXPRESS + ' Werktage bis zur Hochzeit – bitte fragt vor ' +
          'der Bestellung kurz per E-Mail an hi@soonwedding.de, ob wir es möglich machen können.';
      }

      result.textContent = text;
      result.dataset.status = status;
      result.hidden = false;
    }

    input.addEventListener('change', update);
    input.addEventListener('input', update);

    /* Produktübergreifend vorbelegen */
    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved && new Date(saved + 'T00:00:00') >= heute) {
        input.value = saved;
        update();
      }
    } catch (e) { /* privat-modus */ }
  }

  function boot() {
    document.querySelectorAll('[data-liefer-check]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
